<template>
  <div id="fee_main">
    <div class="main">
      <TitleBar
        :title="feeTypeName"
        :introduction="{
          link: 'https://www.smartdaily.com.tw/mau/',
          product_id: 'management_fee',
          product_name: '管理費',
          subpage_name: tabName
        }"
        :tip="`建立${feeTypeName}繳費明細`"
      >
        <template #hint>
          <span
            v-if="accountConfig && accountConfig.HasAccountAnomaly"
            class="title-hint"
            @click="checkAccountInfo"
          >
            <i class="icon-info"> </i>
            {{ $t('Fee.TitleHint') }}
          </span>
        </template>
        <template #btns>
          <el-button
            icon="icon-setting"
            round
            @click="editConfig=true"
          >
            設定
          </el-button>
        </template>
      </TitleBar>
      <fee-tabs
        :config-data="configData"
        :period-data="periodData"
        :period-data-new="periodDataNew"
        @updatePeriod="getPeriodList(false)"
      />
      <div class="tabContent">
        <router-view
          v-loading.fullscreen.lock="pageLoading"
          :period-data="periodData"
          :period-data-new="periodDataNew"
          :config-data="configData"
          :period-data-end="periodDataEnd"
          :period-loading="periodLoading"
          @getMorePeriod="autoShowPeriodList"
          @updatePeriod="getPeriodList(false)"
        />
      </div>
    </div>
    <el-dialog
      title="設定"
      :visible.sync="editConfig"
      :close-on-click-modal="false"
      :show-close="false"
      :lock-scroll="true"
      center
      @closed="resetForm('feeConfigEdit')"
    >
      <el-form
        ref="feeConfigEdit"
        :model="configData"
        status-icon
        :rules="editRule"
        class="demo-ruleForm"
        @submit.native.prevent
      >
        <div class="basicSetting">
          <div class="block">
            <div class="block_left">
              <h4>繳費單</h4>
              <el-button
                size="mini"
                plain
                @click="handlePreview('bill')"
              >
                預覽
              </el-button>
            </div>
            <div class="block_right">
              <el-form-item
                class="half"
                label="社區名稱"
                prop="CommitteeName"
              >
                <el-input
                  v-model="configData.CommitteeName"
                  size="small"
                  maxlength="20"
                  placeholder="限20字"
                />
              </el-form-item>
              <el-form-item
                class="half"
                label="社區電話"
                prop="CommitteeTel"
              >
                <el-input
                  v-model="configData.CommitteeTel"
                  size="small"
                  maxlength="15"
                  placeholder="限15字"
                />
              </el-form-item>
              <el-form-item
                label="社區地址"
                prop="CommitteeAddress"
              >
                <el-input
                  v-model="configData.CommitteeAddress"
                  size="small"
                  maxlength="45"
                  placeholder="限45字"
                />
              </el-form-item>
              <el-form-item
                label="繳費方式"
                prop="ConfigPayWays"
              >
                <br>
                <div v-if="!isDataServiceFeeAgreed" class="config-pay-ways-instructions">
                  <template v-if="isDataServiceFeeAgreedSecondVersion">
                    <span>{{ $t('Fee.SecondVersionConfigPayWaysInstructions[0]') }}</span>
                    <span class="link" @click="$toExternaLink('https://forms.gle/G2wkZDgwTEu4ncvq9')">{{ $t('Fee.SecondVersionConfigPayWaysInstructions[1]') }}</span>
                    <span>{{ $t('Fee.SecondVersionConfigPayWaysInstructions[2]') }}</span>
                  </template>
                  <template v-else>
                    <span>{{ $t('Fee.ConfigPayWaysInstructions[0]') }}</span>
                    <span class="link" @click="$toExternaLink('https://forms.gle/G2wkZDgwTEu4ncvq9')">{{ $t('Fee.ConfigPayWaysInstructions[1]') }}</span>
                    <span>{{ $t('Fee.ConfigPayWaysInstructions[2]') }}</span>
                  </template>
                </div>
                <el-checkbox-group
                  v-model="configData.checkList"
                  class="whole"
                >
                  <el-checkbox
                    v-for="(val) in configData.ConfigPayWays"
                    :key="val.Id"
                    :label="val.Id"
                    :value="val.Switch"
                    :disabled="val.disabled"
                  >
                    {{ val.Name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="ConfigHandlingFeeModeId" class="independent">
                <template slot="label">
                  <span class="click-label" @click="isShowFeeDescription = !isShowFeeDescription">
                    {{ $t("Fee.FeeDescription") }}
                    <i class="icon-arrow-right2" :class="{rotate: isShowFeeDescription}"></i>
                  </span>
                </template>
                <transition name="collapse">
                  <div v-show="isShowFeeDescription">
                    <FeeDescription />
                  </div>
                </transition>
              </el-form-item>
              <el-form-item label="期別備註">
                <el-input
                  v-model="configData.Note"
                  type="textarea"
                  maxlength="80"
                  :autosize="{ minRows: 3}"
                  placeholder="限80字"
                  resize="none"
                />
                <span class="num">{{ configData.Note.length || 0 }}/80</span>
              </el-form-item>
              <el-form-item label="期別通訊欄">
                <el-input
                  v-model="configData.CommunicationBar"
                  type="textarea"
                  maxlength="150"
                  :autosize="{ minRows: 3}"
                  placeholder="限150字，期別通訊欄＋戶別通訊欄最多顯示12行"
                  resize="none"
                />
                <span class="num">{{ configData.CommunicationBar.length || 0 }}/150</span>
              </el-form-item>
            </div>
          </div>
          <div class="block">
            <div class="block_left">
              <h4>收據</h4>
              <el-button
                size="mini"
                plain
                @click="handlePreview('receipt')"
              >
                預覽
              </el-button>
            </div>
            <div class="block_right">
              <el-form-item label="收據開立注意事項">
                <el-input
                  v-model="configData.ReceiptNotice"
                  type="textarea"
                  maxlength="250"
                  :autosize="{ minRows: 3}"
                  placeholder="限250字，最多顯示5行"
                  resize="none"
                />
                <span class="num">{{ configData.ReceiptNotice.length || 0 }}/250</span>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="handleCancelEdit()"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="handleSaveEdit('feeConfigEdit')"
        >
          <span>儲存</span>
          <span v-show="!isDataEqual(configData.ConfigPayWays, configDataOri.ConfigPayWays)">(繳費方式的更動將套用到所有未啟用的期別)</span>
        </el-button>
      </span>
    </el-dialog>
    <!-- 修改收款帳戶 -->
    <BeneficiaryAccountUpdate
      :dialog-visible="isShowUpdateAccountDialog"
      @close="isShowUpdateAccountDialog = false"
      @nextStep="isShowApplyingAccountDialog = true"
    />
    <!-- 收款帳戶申請中 -->
    <BeneficiaryAccountApplying
      :dialog-visible="isShowApplyingAccountDialog"
      :is-show-next-button="false"
      @update="updateAccountConfig"
      @close="isShowApplyingAccountDialog = false"
    />
  </div>
</template>
<script>
import TitleBar from '@/components/PageTitleBar.vue'
import { mapState } from 'vuex'
import FeeTabs from '@/views/ManagementFeeKGI/components/FeeTabs'
import BeneficiaryAccountUpdate from './components/BeneficiaryAccountUpdate.vue'
import BeneficiaryAccountApplying from './components/BeneficiaryAccountApplying.vue'
import FeeDescription from './components/FeeDescription.vue'
export default {
  components: {
    TitleBar,
    'fee-tabs': FeeTabs,
    BeneficiaryAccountUpdate,
    BeneficiaryAccountApplying,
    FeeDescription
  },
  data () {
    const validatePhone = (rule, value, callback) => {
      const pattern = new RegExp(/^[0-9]{0,15}$/)
      if (value.toString().length === 0) {
        callback()
      } else if (!value.toString().match(pattern)) {
        callback(new Error('請輸入正確格式'))
      } else {
        callback()
      }
    }
    return {
      pageLoading: false,
      periodData: [],
      offset: 0,
      limit: 30,
      periodDataEnd: false,
      periodLoading: false,
      periodDataNew: 0,
      configDataFirst: false,
      configData: {
        CommitteeName: '',
        CommitteeTel: '',
        CommitteeAddress: '',
        Note: '',
        CommunicationBar: '',
        ReceiptNotice: '',
        HandlingFeeMode: 0,
        HandlingFeeModeName: '',
        ConfigPayWays: []
      },
      configDataOri: {},
      editConfig: false,
      editRule: {
        CommitteeName: [
          { required: true, message: '請輸入社區名稱', trigger: 'change' }
        ],
        CommitteeAddress: [
          { required: true, message: '請輸入社區地址', trigger: 'change' }
        ],
        CommitteeTel: [
          { required: true, message: '請輸入社區電話', trigger: 'change' },
          { validator: validatePhone, trigger: 'change' }
        ]
      },
      feeType: 'management',
      isShowUpdateAccountDialog: false,
      isShowApplyingAccountDialog: false,
      isShowFeeDescription: false
    }
  },
  computed: {
    ...mapState({
      accountConfig: state => state.fee.accountConfig,
      isDataServiceFeeAgreed: state => state.fee.isDataServiceFeeAgreed
    }),
    feeTypeName () {
      switch (this.feeType) {
        case 'other-management':
          return '其他費用'
        case 'management':
          return '管理費'
        default:
          return '管理費'
      }
    },
    isDataServiceFeeAgreedSecondVersion () {
      const secondVersionDate = process.env.VUE_APP_ENV === 'dev' ? '2025/11/28 12:00:00' : '2025/12/23 00:00:00'
      return new Date() >= new Date(secondVersionDate)
    },
    tabName () {
      const routeName = this.$route.name
      switch (routeName) {
      case 'KGIFeePeriodList':
        return '期別列表'
      case 'KGIFeePaymentList':
        return '繳費列表'
      case 'KGIFeeDeposit':
        return '入帳報表'
      default:
        return ''
      }
    }
  },
  watch: {
    configData (val) {
      this.$store.dispatch('FeeUpdateConfig', val).then(() => {
        console.log(this.$store.state.fee)
      })
    },
    'configData.checkList' (configs) {
      this.configData.ConfigPayWays.forEach(element => {
        element.Switch = configs.includes(element.Id)
      })
    }
  },
  mounted () {
    this.pageLoading = true
    this.getPeriodList(false)
    this.getConfigData()
    this.getAccountConfig()
    this.feeType = this.$route.params.type
  },
  methods: {
    autoShowPeriodList () {
      this.$handleScroll(this.getPeriodList)
    },
    getPeriodList (getMore = true) { // 取得期別列表
      if (getMore) {
        this.periodLoading = true
      } else {
        this.pageLoading = true
      }
      if (!getMore) {
        this.offset = 0
      } else {
        this.offset += this.limit
      }
      const requestData = {
        MaxCount: this.limit,
        Offset: this.offset
      }
      return apiBillserviceKGI.BillBulk.GetBillBulkList(
        requestData
      ).then(async (res) => {
        await this.$sleep(1000, res.duration)
        // eslint-disable-next-line eqeqeq
        if (res.data.BillBulks && (this.offset > 0 || (this.offset == 0 && res.data.BillBulks.length > 0))) {
          console.log(res.data.BillBulks.length)
          if (res.data.BillBulks.length >= this.limit) {
            this.periodDataEnd = false
          } else {
            this.periodDataEnd = true
          }
          console.log(this.periodDataEnd)
          const oriPeriodData = res.data.BillBulks.map((e) => {
            const isInacvtive = ['未啟用', '關閉'].includes(e.BillBulkStatusName)
            e.LastEntryDate = this.$formatDate(e.LastEntryDate)
            e.CreateDate = this.$formatDate(e.CreateDate)
            e.TotalActualAmountString = isInacvtive ? '-' : isNaN(Number(e.TotalActualAmount)) ? e.TotalActualAmount : Number(e.TotalActualAmount).toLocaleString()
            e.TotalShouldAmountString = isInacvtive ? '-' : isNaN(Number(e.TotalShouldAmount)) ? e.TotalShouldAmount : Number(e.TotalShouldAmount).toLocaleString()
            e = Object.assign({}, e, {
              PayRate: isInacvtive ? '-/-' : `${e.PaymentsCount || 0}/${e.BillsCount || 0}`,
              PayFeeRate: isInacvtive ? '-/-' : `${e.TotalActualAmount || 0}/${e.TotalShouldAmount || 0}`
            })
            switch (e.BillBulkStatusName) {
              case '未啟用':
                e.StatusColor = 'danger'
                e.StatusText = '未啟用'
                break
              case '開啟':
                e.StatusColor = 'success'
                e.StatusText = '啟用中'
                break
              case '關閉':
                e.StatusText = '已關閉'
                break
              default:
                e.StatusText = ''
            }
            return e
          }).filter((ele) => {
            // eslint-disable-next-line eqeqeq
            if (ele.BillBulkStatusName != '刪除') {
              return ele
            }
          })
          if (getMore) {
            this.periodData = [...this.periodData, ...oriPeriodData]
          } else {
            this.periodData = _cloneDeep(oriPeriodData)
          }
          const sortPeriod = _cloneDeep(this.periodData)
          sortPeriod.sort(function (a, b) {
            return b.BillBulkId - a.BillBulkId
          })
          this.periodDataNew = sortPeriod[0].BillBulkId ? sortPeriod[0].BillBulkId : 0
        } else {
          this.periodData = res.data.BillBulks
          this.periodDataEnd = true
        }
        this.pageLoading = false
        this.periodLoading = false
        return true
      }).catch(async (err) => {
        console.log(err)
        console.log(err.response)
        this.$message({
          message: '取得期別列表失敗，請稍後再試',
          type: 'warning'
        })
        this.pageLoading = false
        this.periodLoading = false
        return false
      })
    },
    getConfigData () { // 取得社區基本設定
      apiBillserviceKGI.Config.GetCommunitySettingForm(
      ).then((res) => {
        console.log('getConfigData:', res)
        if (res.data) {
          this.$store.commit('setFeeIsDataServiceFeeAgreed', res.data.IsDataServiceFeeAgreed)
          res.data.ConfigPayWays.map(element => {
            if (element.Id === 4) element.disabled = true
            // 若沒有同意協議，則 ATM / 全盈+ / 玉山轉帳 停止使用。第二階段啟用
            if (
              !res.data.IsDataServiceFeeAgreed &&
              [1, 5, 6].includes(element.Id) &&
              this.isDataServiceFeeAgreedSecondVersion
            ) element.disabled = true

            return element
          })
          const checkArray = res.data.ConfigPayWays.filter(element => element.Switch).map(element => element.Id)
          this.configData = Object.assign({}, res.data, { checkList: _cloneDeep(checkArray) })
          this.configDataOri = _cloneDeep(this.configData)
        }
      }).catch((err) => {
        console.log(err.response)
        this.$message({
          message: '取得社區基本設定失敗，請稍後再試',
          type: 'warning'
        })
      })
    },
    async getAccountConfig () { // 取得社區帳號設定檔
      try {
        const res = await apiBillserviceKGI.Config.GetCommunityAccount()
        if (res.data) {
          this.$store.commit('setFeeAccountConfig', res.data)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async updateAccountConfig () { // 更新社區帳號設定檔
      this.pageLoading = true
      await this.getAccountConfig()
      this.pageLoading = false
    },
    handleCancelEdit () { // 社區基本設定 - 取消編輯
      this.configData = _cloneDeep(this.configDataOri)
      this.editConfig = false
      console.log(_isEqual(this.configData, this.configDataOri))
    },
    handleSaveEdit (formName) { // 社區基本設定 - 儲存編輯
      console.log('saved')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!_isEqual(this.configData, this.configDataOri)) {
            this.pageLoading = true
            console.log('handleSaveEdit:', this.configData)
            const { CommitteeName, CommitteeTel, CommitteeAddress, Note, CommunicationBar, ReceiptNotice } = this.configData
            console.log(CommitteeName)
            const requestData = {
              CommitteeName,
              CommitteeTel,
              CommitteeAddress,
              Note,
              CommunicationBar,
              ReceiptNotice,
              ConfigPayWays: this.configData.ConfigPayWays.map((val) => {
                return {
                  Id: val.Id,
                  Switch: val.Switch
                }
              })
            }
            apiBillserviceKGI.Config.PutCommunitySettingForm(
              requestData
            ).then((res) => {
              this.configDataOri = _cloneDeep(this.configData)
              this.editConfig = false
              this.pageLoading = false
              this.$message({
                message: '修改社區基本設定成功',
                type: 'success'
              })
              this.getConfigData()
              this.getPeriodList(false)
            }).catch((err) => {
              this.pageLoading = false
              this.$message({
                message: '修改社區基本設定失敗，請稍後再試',
                type: 'warning'
              })
              console.log(err.response)
            })
          } else {
            this.editConfig = false
          }
        } else {
          this.$message({
            showClose: true,
            message: '修改社區基本設定失敗 - 請確認各欄位均已填妥',
            type: 'warning'
          })
          return false
        }
      })
    },
    handlePreview (page) { // 預覽繳費單bill receipt
      let routeData
      switch (page) {
        case 'bill':
          routeData = this.$router.resolve(
            {
              name: 'KGIPrintBillPreview',
              params: { type: this.feeType }
            }
           )
          break
        case 'receipt':
          routeData = this.$router.resolve(
            {
              name: 'KGIPrintReceiptPreview',
              params: { type: this.feeType }
            }
          )
          break
      }
      window.open(routeData.href, '_blank')
    },
    resetForm (formName) { // 重置表格資料
      this.configData = _cloneDeep(this.configDataOri)
      this.$refs[formName].resetFields()
      if (formName === 'feeConfigEdit') this.isShowFeeDescription = false
    },
    isDataEqual (a, b) {
      return _isEqual(a, b)
    },
    checkAccountInfo () { // 確認帳戶異動狀況
      if (this.accountConfig.AccountUpdateDraft) { // 已送出申請資料
        this.isShowApplyingAccountDialog = true
      } else { // 未送出申請資料
        this.isShowUpdateAccountDialog = true
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.collapse-enter-active,
.collapse-leave-active
  transition: all 0.3s ease
  overflow: hidden

.collapse-enter,
.collapse-leave-to
  max-height: 0

.collapse-enter-to,
.collapse-leave
  max-height: 700px

#fee_main
  +mainLayer
  text-align: center
  padding: 50px 0 10px
  .title
    display: flex
    align-items: center
  .title-hint
    cursor: pointer
    display: flex
    align-items: center
    gap: 4px
    padding: 8px 13px
    border-radius: 20px
    background-color: $warnColor
    color: $white
    font-size: 14px
    font-weight: normal
  ::v-deep .el-dialog
    +basicDialog
    .el-checkbox__label
      font-size: map-get($fontSize,small)
      vertical-align: middle
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after
      border-color: $subFontColor
    .el-checkbox__input.is-disabled + span.el-checkbox__label
      color: $subFontColor
    .basicSetting
      width: 100%
      .block
        display: flex
        flex-wrap: wrap
        &:first-child
          border-bottom: dashed 1px $borderDark1
        &:not(:first-child)
          margin-top: 15px
        .block_left
          width: 20%
        .block_right
          display: flex
          flex-wrap: wrap
          width: 80%
      .down
        border-top: dashed 1px $borderDark1
      .independent
        .el-form-item__label
          float: none
          display: block
          text-align: left
          margin-bottom: 4px
        .click-label
          cursor: pointer
          .icon-arrow-right2
            display: inline-block
            transition: transform 0.2s ease-in-out
            &.rotate
              transform: rotate(90deg)
      .config-pay-ways-instructions
        color: $warnColor
        line-height: 20px
        margin-bottom: 8px
        .link
          font-weight: bold
          text-decoration: underline
          cursor: pointer
  .list_info
    display: flex
    justify-content: flex-end
    align-items: center
    margin: 20px 0
    .result
      margin: 0 10px

</style>
